import { createTheme } from "@mui/material/styles";

const lightTheme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: "#fff",
      paper: "#eee",
    },
    primary: {
      main: "#00adeb",
    },
    secondary: {
      main: "#364153",
    },
  },
  typography: {
    fontFamily: `'Sora', sans-serif`,
  },
});

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#030712",
      paper: "#030712",
    },
    primary: {
      main: "#235bdd",
    },
    secondary: {
      main: "#364153",
    },
  },
  typography: {
    fontFamily: `'Sora', sans-serif`,
  },
});

export { lightTheme, darkTheme };
